
export function notEmpty(str: string | null | undefined): boolean {
  return (str && str.trim().length > 0) ? true : false
}

// from https://stackoverflow.com/a/34842797/335615
export function hashCode(str: string): number {
  return str.split('').reduce((prevHash, currVal) =>
    (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0)
}

export function readTextFile(file: File): Promise<string> {
  const fileReader = new FileReader()
  return new Promise((resolve, reject) => {
    fileReader.onload = (e) => resolve(fileReader.result as string)
    fileReader.onerror = (e) => reject(fileReader.error)
    fileReader.readAsText(file)
  })
}

export function readBinaryStringFile(file: File): Promise<string> {
  const fileReader = new FileReader()
  return new Promise((resolve, reject) => {
    fileReader.onload = (e) => resolve(fileReader.result as string)
    fileReader.onerror = (e) => reject(fileReader.error)
    fileReader.readAsBinaryString(file)
  })
}

//https://stackoverflow.com/a/14601808/335615
export function decodeUTF16LE(binaryStr: string) {
  const cp = []
  for (let i=0; i<binaryStr.length; i+=2) {
    cp.push( 
      binaryStr.charCodeAt(i) |
      ( binaryStr.charCodeAt(i+1) << 8 )
    )
  }
  return String.fromCharCode.apply(String, cp)
}

// UTF-16 files without BOM have alternating \x00 
// we check this on the first 10 bytes
export function isUTF16LEWithoutBOM(binaryStr: string): boolean {
  if (binaryStr.length < 2) return false
  for(let i=1; i<10 && i<binaryStr.length; i+=2) {
    if (binaryStr.charCodeAt(i) != 0x00)
      return false
  }
  return true
}
